export enum Environment {
  dev = 'dev',
  stage = 'stage',
  prod = 'prod',
}
